




























































import logo from '@/assets/logo.png';
import { Component, Vue, Prop } from 'vue-property-decorator';
import LoginForm from '@/components/form/LoginForm.vue';
import Spinner from '@/components/ui/Spinner.vue';
import { mapGetters, mapActions } from 'vuex';

@Component({
  computed: {

  },
  methods: {
    
  },
  components: {
    LoginForm,
    Spinner,
  },
})
export default class Login extends Vue {

  successfulLogin() {
    this.$router.push({name: 'dashboard-orders'});
  }

  onFetchingDataStateChange(state: boolean) {
    if (state) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  }

  loading: boolean = true;

  get logo() {
    return logo;
  }

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 300);
  }
}
